import { useApolloClient } from '@apollo/client';
import {
  LandingPageHeader,
  type LandingPageItem,
  LandingPageTiles,
} from '@axinom/mosaic-ui';
import React, { useEffect, useState } from 'react';
import {
  EnvironmentsDocument,
  type EnvironmentsQuery,
  TenantAdminsDocument,
  type TenantAdminsQuery,
} from '../../../../generated/id-service-env-administration';
import logoAdm from '../../../../images/administrators.svg';
import logoEnv from '../../../../images/environments.svg';
import { authStateStore } from '../../../../state-store';
import classes from './Home.module.scss';

export const Home: React.FC = () => {
  const apolloClient = useApolloClient();
  const tenantName = authStateStore.useState('tenantName');

  const useLandingPageData = (): LandingPageItem[] => {
    const [landingPageData, setLandingPageData] = useState<LandingPageItem[]>(
      [],
    );

    useEffect(() => {
      const loadEnvironmentCount = async (): Promise<number | string> => {
        const result = await apolloClient.query<EnvironmentsQuery>({
          query: EnvironmentsDocument,
          fetchPolicy: 'network-only',
        });

        return result.data.environments?.totalCount ?? '';
      };

      const loadTenantAdminsCount = async (): Promise<number | string> => {
        const result = await apolloClient.query<TenantAdminsQuery>({
          query: TenantAdminsDocument,
          fetchPolicy: 'network-only',
        });

        return result.data.tenantAdmins?.totalCount ?? '';
      };

      setLandingPageData([
        {
          path: '/env',
          label: 'Environments',
          icon: logoEnv,
          type: 'large',
          subtitle: loadEnvironmentCount,
        },
        {
          path: '/tenantAdmin',
          label: 'Administrators',
          icon: logoAdm,
          type: 'large',
          subtitle: loadTenantAdminsCount,
        },
      ]);
    }, []);

    return landingPageData;
  };

  const landingPageData = useLandingPageData();
  return (
    <div className={classes.container}>
      <LandingPageHeader
        title="Environment Administration Portal"
        subtitle={tenantName}
      />
      <LandingPageTiles
        items={landingPageData}
        gridTemplateColumns={8}
        gridRowHeight="32px"
        gridGap="5px"
        minWidth="600px"
        maxWidth="900px"
        alignment="center"
        largeTileColumnSpan={2}
        largeTileRowSpan={6}
        smallTileColumnSpan={1}
        smallTileRowSpan={3}
      />
    </div>
  );
};
